<template>
  <div>
      <v-card color="white" outlined class="pa-2 pt-5">
        <v-card class="header-card allign-middle px-2 mx-2" :color="color" style="top: 0;left:0;right:0;position: absolute;margin-top: -50px;">
          <div class="row">
            <div class="text-left">
              <div>
                <v-card-title class="text-left">{{headline}}</v-card-title>
                <v-card-subtitle class="text-left">{{description}}</v-card-subtitle>
              </div>
            </div>
            <div class="row justify-content-end align-self-center" style="padding-right:40px">
              <div>
                <v-select
                v-model="chart.chartType"
                flat
                :items="chart.availableChartTypes"
                item-text="name"
                item-value="value"
                class="chart-selector pa-0 ma-0"
                hide-details>
                <template v-slot:prepend>
                  <v-icon v-show="chart.chartType == 'LINE'" color="white">fas fa-chart-line</v-icon>
                  <v-icon v-show="chart.chartType == 'BAR'" color="white">fas fa-chart-bar</v-icon>
                  <v-icon v-show="chart.chartType == 'RADAR'" color="white">fas fa-chart-area</v-icon>
                  <v-icon v-show="chart.chartType == 'BUBBLE'" color="white">fas fa-chart-area</v-icon>
                  <v-icon v-show="chart.chartType == 'PIE'" color="white">fas fa-chart-pie</v-icon>
                </template>
                <template v-slot:append>
                  <v-icon color="white">fas fa-chevron-down</v-icon>
                </template>
                </v-select>
              </div>
            </div>
          </div>
        </v-card>
        <line-chart ref="updateChart" class="mt-5" v-if="chart.chartType == 'LINE' && renderComponent" :chartData="chart.data" :options="chartOptions"/>
        <bar-chart ref="updateChart" class="mt-5" v-if="chart.chartType == 'BAR' && renderComponent" :chartData="chart.data" :options="chartOptions"/>
        <radar-chart ref="updateChart" class="mt-5" v-if="chart.chartType == 'RADAR' && renderComponent" :chartData="chart.data" :options="chartOptions"/>
        <bubble-chart ref="updateChart" class="mt-5" v-if="chart.chartType == 'BUBBLE' && renderComponent" :chartData="chart.data" :options="chartOptions"/>
        <pie-chart ref="updateChart" class="mt-5" v-bind:class="{'shrink': chart.size == 'SMALL'}" v-if="chart.chartType == 'PIE' && renderComponent" :chartData="chart.data" :options="chartOptions"/>
      </v-card>
  </div>
</template>

<script>
import LineChart from '../charts/Line'
import BarChart from '../charts/Bar'
import RadarChart from '../charts/Radar'
import BubbleChart from '../charts/Bubble'
import PieChart from '../charts/Pie'

export default {
  components: {
    LineChart,
    BarChart,
    RadarChart,
    BubbleChart,
    PieChart,
  },

  props: {
        color: String,
        headline:String,
        description: String,
        chart: Object,
        dashboard: Object,
    },

  data() {
    return {
      data: null,

      dataPath: null,
      theses: [],

      renderComponent: true,

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handleChartClick,
      },
    }
  },
  mounted() {
    this.dataPath = this.chart.dataPath;
    
    // Add Stacking to Bar Charts
    if(this.chart.chartType == "BAR"){
      this.chartOptions.scales = {
        yAxes: [{
          stacked:true
        }],
        xAxes: [{
          stacked:true
        }],
      };
    }
    if(this.chart.hideLegend){
      this.chartOptions.legend = {
        display: false,
      };
    }
    this.convertChartnames();
  },
  methods: {

    handleChartClick(point, event){
      const item = event[0];
      if(item == null) return;
      if(item._index == null) return;
      const label = this.chart.data.labels[item._index];
      var datasetIndex = null;

      if(this.chart.data.datasets.length > 1){
        const chartIndex = item._chart.getElementAtEvent(point);
        if (chartIndex.length !== 0) {
          datasetIndex = chartIndex[0]._datasetIndex;
          console.log("DS-Index: " + datasetIndex);
        }
      }

      var path = this.dataPath + "/" + label;
      if(datasetIndex != null){
        path += "/" + datasetIndex;
      }
      console.log(this.$parent.$parent.$parent);
      this.$emit("fetchTheses", path);
    },
    
    convertChartnames(){
      const chartlist = [];
      for (var i in this.chart.availableChartTypes){
        var chart = {};
        if(this.chart.availableChartTypes[i] == 'BAR'){
          chart.value = 'BAR'
          chart.name = this.$t("BAR")
          chartlist.push(chart);
        } else if (this.chart.availableChartTypes[i] == 'LINE') {
          chart.value = 'LINE'
          chart.name = this.$t('LINE')
          chartlist.push(chart);
        } else if (this.chart.availableChartTypes[i] == 'RADAR') {
          chart.value = 'RADAR'
          chart.name = this.$t('RADAR')
          chartlist.push(chart);
        } else if (this.chart.availableChartTypes[i] == 'BUBBLE') {
          chart.value = 'BUBBLE'
          chart.name = this.$t('BUBBLE')
          chartlist.push(chart);
        } else if (this.chart.availableChartTypes[i] == 'PIE') {
          chart.value = 'PIE'
          chart.name = this.$t('PIE')
          chartlist.push(chart);
        }
      }
      this.chart.availableChartTypes = chartlist;
    },

    update(){
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },

  }

}
</script>

<style scoped>
  .icon-container{
      position: absolute;
      top: 0;
      margin-top: -20px;
      height: 5vw;
      width: 5vw;
  }
</style>